
import styles from './Loader.module.css';

const Loader = () => {
    return (<div className={styles.loading}>Loading&#8230;</div>)
}
export default Loader;